import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaPrayingHands } from 'react-icons/fa';

const { FiBook, FiBookOpen, FiHome, FiUser } = FiIcons;

const MobileNav = () => {
    const location = useLocation();

    const navItems = [
        { name: 'Home', path: '/', icon: FiHome },
        { name: 'Quran', path: '/quran', icon: FiBook },
        { name: 'Hadith', path: '/hadith', icon: FiBookOpen },
        { name: 'Duas', path: '/duas', icon: FaPrayingHands },
        { name: 'Profile', path: '/profile', icon: FiUser }
    ];

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-md border-t border-emerald-200 dark:border-gray-700">
            <div className="flex justify-around items-center py-2">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.path;

                    return (
                        <Link
                            key={item.name}
                            to={item.path}
                            className="flex flex-col items-center py-2 px-3 min-w-0 flex-1"
                        >
                            <motion.div
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                                className={`p-2 rounded-lg transition-colors duration-200 ${isActive
                                        ? 'bg-emerald-600 text-white'
                                        : 'text-gray-600 dark:text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400'
                                    }`}
                            >
                                <SafeIcon icon={item.icon} className="w-5 h-5" />
                            </motion.div>
                            <span className={`text-xs mt-1 font-medium ${isActive
                                    ? 'text-emerald-600 dark:text-emerald-400'
                                    : 'text-gray-600 dark:text-gray-400'
                                }`}>
                                {item.name}
                            </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileNav;